import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IssueListComponent } from './issue-list/issue-list.component';
import { IssueDialogComponent } from './issue-dialog/issue-dialog.component';
import { Route, RouterModule } from '@angular/router';
import { HttpClientModule } from '@angular/common/http';
import { SharedComponentsModule } from '../shared-components-module/shared-components.module';
import { FormsModule } from '@angular/forms';
import { NotesDialogComponent } from './notes-dialog/notes-dialog.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgbNavModule } from '@ng-bootstrap/ng-bootstrap';

let routes: Route[] = [
  { path: 'issues', component: IssueListComponent }
]

@NgModule({
    declarations: [IssueListComponent, IssueDialogComponent, NotesDialogComponent],
    imports: [
        CommonModule,
        FormsModule,
        NgbModule,
        SharedComponentsModule,
        RouterModule.forRoot(routes),
        HttpClientModule,
        NgbNavModule
    ]
})
export class IssueTrackerModule { }
